// extracted by mini-css-extract-plugin
export default {"heading":"Qp-z","createAccount":"Rp-z","disabled":"Sp-z","copy":"Tp-z","terms":"Up-z"};